module.exports = __webpack_public_path__ + "static/img/witness-kids-1.16e99684.png";